module.exports = "pegasus/assets/square-snapchat.png";